import {Ticket} from "../../../../core/entities/ticket/domain/model/ticket.model";
import {DomainEvent} from "@platform/event-bus/domain/model/domain-event.model";

export class BookingTicketGeneratedEvent implements DomainEvent {
  readonly occurredAt = new Date();

  constructor(readonly payload: Ticket) {
  }
}
